export default __webpack_public_path__ + "static/media/logo-header.4d336c4b.png";